import { faCode, faImages, faPencil, faToolbox } from '@fortawesome/free-solid-svg-icons';
import { faAws, faCss3, faFigma, faHtml5, faJs, faReact, faSass, faWordpress } from '@fortawesome/free-brands-svg-icons';


export const skillsList = [
  {
    name: 'HTML',
    iconName: faHtml5
  },
  {
    name: 'CSS',
    iconName: faCss3
  },
  {
    name: 'Sass',
    iconName: faSass
  },
  {
    name: 'Ruby',
    iconName: faCode
  },
  {
    name: 'Rails',
    iconName: faCode
  },
  {
    name: 'Javascript',
    iconName: faJs
  },
  {
    name: 'React',
    iconName: faReact
  },
  {
    name: 'jQuery',
    iconName: faCode
  },
  {
    name: 'illustrator',
    iconName: faPencil
  },
  {
    name: 'photoshop',
    iconName: faImages
  },
  {
    name: 'AffinityDesigner',
    iconName: faPencil
  },
  {
    name: 'AffinityPhoto',
    iconName: faImages
  },
  {
    name: 'Firebase',
    iconName: faToolbox
  },
  {
    name: 'AWS',
    iconName: faAws
  },
  {
    name: 'Wordpress',
    iconName: faWordpress
  },
  {
    name: 'Figma',
    iconName: faFigma
  }
];